<template>
  <div class="services_management_home">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "ServicesManagementHome",
};
</script>

<style scoped>
</style>
